const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 100,
    viewBox: "0 0 136 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_726_5625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.7366 71.8606L68.6992 79.9717L95.6076 100L101.645 91.8892L74.7366 71.8606Z",
    fill: "url(#paint0_linear_726_5625)",
    fillOpacity: 0.59,
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.123 72.8784L97.1378 85.5442L121.86 65.3245C123.839 63.7067 125.613 61.8509 127.138 59.798L129.414 56.7391C131.592 53.8132 132.862 50.3089 133.059 46.6638L135.171 8.05221C135.348 4.82178 132.998 2.00604 129.79 1.59903C126.36 1.16643 123.245 3.63405 122.887 7.07182L120.268 32.0757C120.217 32.5671 120.355 33.0612 120.667 33.4451C121.21 34.1158 121.875 35.1551 122.229 36.5527C122.423 37.3206 122.485 38.0476 122.467 38.7106C122.426 40.2132 121.945 41.6722 121.128 42.9342C118.177 47.4983 115.223 52.0624 112.271 56.6264C111.9 57.1998 111.296 57.5812 110.62 57.6682L109.048 57.8705C108.598 57.9293 108.283 57.4379 108.524 57.0513L118.189 41.5084C119.528 39.3556 119.126 36.5117 117.171 34.8991C114.962 33.0765 111.667 33.4682 109.949 35.7745L100.542 48.4121C100.23 48.8319 99.823 49.1775 99.3546 49.4155L94.6472 51.8269C91.6804 53.3474 89.0464 55.4361 86.8911 57.978L86.1871 58.8073C83.4405 62.0455 81.554 65.921 80.699 70.078L80.123 72.8784Z",
    fill: "url(#paint1_linear_726_5625)",
    fillOpacity: 0.59,
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5388 91.8879L39.5762 99.999L66.4846 79.9704L60.4472 71.8592L33.5388 91.8879Z",
    fill: "url(#paint2_linear_726_5625)",
    fillOpacity: 0.59,
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.067 72.8713L38.0522 85.5371L13.3299 65.3174C11.3512 63.6997 9.57728 61.8438 8.05166 59.7909L5.77602 56.732C3.59766 53.8062 2.32801 50.3018 2.13091 46.6567L0.0190989 8.0477C-0.157525 4.81983 2.19234 2.00152 5.39974 1.59708C8.82983 1.16448 11.9451 3.6321 12.3034 7.06987L14.9221 32.0737C14.9733 32.5652 14.8351 33.0592 14.5228 33.4432C13.9801 34.1138 13.3145 35.1531 12.9613 36.5507C12.7668 37.3187 12.7053 38.0457 12.7232 38.7086C12.7642 40.2112 13.2454 41.6703 14.062 42.9323C17.0134 47.4963 19.9674 52.0604 22.9188 56.6245C23.29 57.1979 23.8941 57.5793 24.5699 57.6663L26.1416 57.8685C26.5921 57.9274 26.9069 57.4359 26.6663 57.0494L17.0006 41.5065C15.6619 39.3537 16.0637 36.5098 18.0194 34.8971C20.2285 33.0746 23.5229 33.4662 25.2405 35.7726L34.6477 48.4102C34.96 48.83 35.367 49.1755 35.8354 49.4136L40.5428 51.8249C43.5096 53.3454 46.1436 55.4342 48.2989 57.976L49.0029 58.8054C51.7495 62.0435 53.6361 65.919 54.491 70.0761L55.067 72.8713Z",
    fill: "url(#paint3_linear_726_5625)",
    fillOpacity: 0.59,
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.5051 45.8738C69.3796 43.6929 69.4513 40.3166 70.7184 36.9786C71.3711 35.261 72.0572 34.3036 72.4207 33.8378C73.4266 32.5502 74.5504 31.7208 75.3977 31.2089C75.6383 31.063 75.9199 31.0041 76.1989 31.0348C77.8397 31.2268 80.2971 31.2959 83.1128 30.5357C87.6334 29.3147 90.4901 26.6627 91.7188 25.3675C91.299 26.2788 88.967 31.0988 83.4405 32.9342C80.0334 34.0656 77.0641 33.5152 75.7304 33.1774C75.0188 34.4803 74.3072 35.7806 73.5956 37.0836C75.0572 37.4931 78.0957 38.1305 81.8022 37.3088C83.077 37.0272 86.1154 36.1979 89.0156 33.7482C90.1138 32.819 90.915 31.8923 92.6761 29.394C94.2197 27.208 96.2598 24.1542 98.4945 20.3017C87.0779 13.2188 75.6204 13.8101 71.3583 19.265C70.6288 20.1968 68.7883 22.9664 69.5076 28.4802C70.7798 27.5254 72.7611 26.266 75.4284 25.3675C78.0624 24.4818 80.3764 24.2821 81.9584 24.2694C79.8056 24.8965 77.041 25.9306 74.0871 27.6866C71.5913 29.1688 69.6331 30.7635 68.1663 32.1406C67.7132 29.8189 66.3847 24.661 62.0843 19.7923C57.5663 14.6779 52.2983 12.7478 50.0431 12.0618C51.8811 12.3715 54.2284 12.9552 56.7958 14.0968C60.2105 15.6148 62.6986 17.5423 64.3215 19.0193C65.3762 15.2103 64.854 12.5686 64.278 10.979C61.4597 3.19732 49.4339 -1.55106 34.4746 0.471162C34.8023 2.49594 35.3117 5.42432 36.0565 8.94656C36.7989 12.4483 37.17 14.2018 37.5054 15.1156C38.926 18.9757 42.4125 24.0031 48.3281 26.2225C52.8077 27.9042 56.8675 27.2976 58.8846 26.8317C58.132 25.4084 57.3794 23.9827 56.6269 22.5594C55.8436 22.7309 50.0099 23.9084 44.9006 19.9024C40.0114 16.0678 39.589 10.4747 39.5404 9.62234C40.1983 11.1812 42.0183 14.9159 46.1625 17.7394C50.5193 20.7087 54.9502 20.9698 56.9673 20.9314C57.341 20.9237 57.6968 21.085 57.94 21.3691C59.5015 23.2173 61.4213 25.9614 62.7934 29.6372C65.4504 36.7533 64.4546 43.076 63.8301 45.8713H69.5051V45.8738Z",
    fill: "url(#paint4_linear_726_5625)",
    fillOpacity: 0.59,
    style: {}
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_726_5625",
    x1: 99.5,
    y1: 124.5,
    x2: 91.1256,
    y2: 61.8133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AB7D9",
    style: {
      stopColor: "#4AB7D9",
      stopColor: "color(display-p3 0.2902 0.7176 0.8510)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AB7D9",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_726_5625",
    x1: 108.835,
    y1: 7.42558,
    x2: 101.096,
    y2: 86.6469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AB7D9",
    style: {
      stopColor: "#4AB7D9",
      stopColor: "color(display-p3 0.2902 0.7176 0.8510)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AB7D9",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_726_5625",
    x1: 66,
    y1: 129.5,
    x2: 74.7269,
    y2: 73.7577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AB7D9",
    style: {
      stopColor: "#4AB7D9",
      stopColor: "color(display-p3 0.2902 0.7176 0.8510)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AB7D9",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_726_5625",
    x1: 28.7215,
    y1: 7.42326,
    x2: 20.9836,
    y2: 86.6399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AB7D9",
    style: {
      stopColor: "#4AB7D9",
      stopColor: "color(display-p3 0.2902 0.7176 0.8510)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AB7D9",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_726_5625",
    x1: 67.8602,
    y1: 3.21361,
    x2: 65.8608,
    y2: 46.7971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AB7D9",
    style: {
      stopColor: "#4AB7D9",
      stopColor: "color(display-p3 0.2902 0.7176 0.8510)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AB7D9",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_726_5625"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 135.189,
    height: 100,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCare);
export default __webpack_public_path__ + "static/media/icon-care.4164aa988f219225387329d6b9cac7c0.svg";
export { ForwardRef as ReactComponent };